import React, { useEffect, useReducer } from "react";
import * as constantes from './constantes';
import { traerDestinosParaCDR, sumarFechaEnJSYDevolverBase } from "../utils/Tools";

const CdrGlobalContext = React.createContext([{}, () => {}]);

const reducer = (state, action) => {
  let { habitaciones } = { ...state.busquedaCDR };
  switch (action.type) {
    case constantes.SET_PROVINCIAS_PARA_HOTELES:
      return {
        ...state,
        provinciasParaHoteles: action.payload.destinos,
      };
    case constantes.UPDATE_BUSCADOR_HOTELES:
      return {
        ...state,
        busquedaCDR: { ...state.busquedaCDR, [action.payload.name]: action.payload.value },
      };
    case constantes.UPDATE_FECHA_IN_HOTELES:
      return {
        ...state,
        busquedaCDR: { ...state.busquedaCDR, fechaIn: action.payload.value, fechaOut: sumarFechaEnJSYDevolverBase(new Date(action.payload.value),4)},
      };
    case constantes.ADD_HABITACION:
      //const { habitaciones } = { ...state.busquedaCDR };
      habitaciones.push({
        adultos: 2,
        menores: [],
        infoa: 0,
      });
      return {
        ...state,
        busquedaCDR: {
          ...state.busquedaCDR,
          habitaciones
        }
      };
      case constantes.REMOVE_HABITACION:
        //const { habitaciones } = { ...state.busquedaCDR };
        habitaciones.pop();
        return {
          ...state,
          busquedaCDR: {
            ...state.busquedaCDR,
            habitaciones
          }
        };
    case constantes.SET_ADULTOS_CANTIDAD:
      //const { habitaciones } = { ...state.busquedaCDR };
      const { index: indexAdultos, cantidad: cantidadAdultos} = action.payload;
      habitaciones[indexAdultos].adultos = cantidadAdultos;
      return {
        ...state,
        busquedaCDR: {
          ...state.busquedaCDR,
          habitaciones: habitaciones
        }
      };
    case constantes.SET_MENORES_CANTIDAD:
      //const { habitaciones } = { ...state.busquedaCDR };
      const { index: indexMenores, cantidad: cantidadMenores} = action.payload;
      habitaciones[indexMenores].menores = new Array(Number(cantidadMenores));
      habitaciones[indexMenores].menores.fill(0);
      return {
        ...state,
        busquedaCDR: {
          ...state.busquedaCDR,
          habitaciones: habitaciones
        }
      };
    case constantes.SET_EDAD_MENORES:
      //const { habitaciones } = { ...state.busquedaCDR };
      const { indiceHab, indiceMenor, edad} = action.payload;
      habitaciones[indiceHab].menores[indiceMenor] = edad;
      return {
        ...state,
        busquedaCDR: {
          ...state.busquedaCDR,
          habitaciones: habitaciones
        }
      };
    case constantes.UPDATE_BUSCADOR_HOTELES_Y_PASAJEROS:
      return {
        ...state,
        busquedaCDR: {destino: action.payload.destino, fechaIn: action.payload.fechaIn, fechaOut: action.payload.fechaOut, habitaciones: action.payload.habitaciones },
        pasajerosAdultos: action.payload.pasajerosAdultos,
        pasajerosMenores: action.payload.pasajerosMenores
      };
    case constantes.SET_PRODUCTO_SELECCIONADO:
      //const infoas = calcularInfoas(state.pasajerosMenores);
      //const pasajerosPagantes = state.pasajerosAdultos.length + state.pasajerosMenores.length - infoas;
      //const totalRegimen = calcularTotalRegimen(action.payload.producto, pasajerosPagantes);
      //const totalCompra = parseFloat(totalRegimen) + action.payload.producto.gastoDeReserva + action.payload.producto.precioAlojamiento;
      return {
        ...state,
        productoSeleccionado: action.payload.producto,
        totalCompra: action.payload.respuesta.totalCompra,
        totalRegimen: action.payload.respuesta.totalRegimen
      };
    case constantes.SET_CDR_OFERTAS:
     
      return {
        ...state,
        cdrOfertas: action.payload
      };
    case constantes.SET_SEGURO_CANCELACION:

      const totalCompraConSeguro = parseFloat(action.payload.totalSeguro) + state.totalCompra;
      const interesesCuota = parseFloat(totalCompraConSeguro) * parseFloat(action.payload.interes / 100);
      return {
        ...state,
        intereses: interesesCuota,
        totalSeguroCancelacion: action.payload.totalSeguro,
        totalCompra: totalCompraConSeguro
      };
    case constantes.SET_INTERES:
      //const totalCompraConInteres = parseFloat(action.payload.interes) + state.totalCompra;
      return {
        ...state,
        intereses: action.payload.interes,
      };
    /* case constantes.SET_REGIMEN_HOTEL:

      const totalCompraConNuevoRegimen = parseFloat(action.payload.regimenSeleccionado.precio) + state.totalCompra;
      return {
        ...state,
        regimenSeleccionado: action.payload.regimenSeleccionado,
        totalCompra: totalCompraConNuevoRegimen
      }; */
    case constantes.SET_PASAJEROS_ADULTOS:
      const { pasajerosAdultos } = { ...state };
      let unPasajeroAdulto = Object.assign({}, pasajerosAdultos[action.payload.indice]);
      unPasajeroAdulto[action.payload.propiedad] = action.payload.valor;
      pasajerosAdultos[action.payload.indice] = unPasajeroAdulto;
      return {
        ...state,
        pasajerosAdultos
      };
    case constantes.SET_PASAJEROS_MENORES:
      const { pasajerosMenores } = { ...state };
      let unPasajeroMenor = Object.assign({}, pasajerosMenores[action.payload.indice]);
      unPasajeroMenor[action.payload.propiedad] = action.payload.valor;
      pasajerosMenores[action.payload.indice] = unPasajeroMenor;
      return {
        ...state,
        pasajerosMenores
      };
    
    default:
      throw new Error();
  }
}

const CdrGlobalProvider = (props) => {
  const initialState = {
    hoteles: [],
    provinciasParaHoteles: [],
    busquedaCDR: {
      destino: "",
      fechaIn:sumarFechaEnJSYDevolverBase(new Date(),1),
      fechaOut: sumarFechaEnJSYDevolverBase(new Date(),4),
      habitaciones: [{ adultos: 2, menores: [] }],
    },
    productoSeleccionado: {},
    //regimenSeleccionado: {},
    cdrOfertas: [],
    totalSeguroCancelacion: 0,
    totalRegimen: 0,
    totalCompra: 0,
    intereses: 0,
    pasajerosAdultos: [],
    pasajerosMenores: [],
  };
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    traerDestinosParaCDR(dispatch);
  }, []);

  const { children } = props;

  return (
    <CdrGlobalContext.Provider value={[state, dispatch]}>
      {children}
    </CdrGlobalContext.Provider>
  );
};

export { CdrGlobalContext, CdrGlobalProvider };



// WEBPACK FOOTER //
// ./src/context/cdrGlobalContext.js